export const localIP = "https://10.1.41.24:8080/"
